import React from 'react'
import { useTranslation } from 'react-i18next'

import TranslationNS from '@/utils/Constants/TranslationNS'
import { initialsOf } from './orgMenu.model'
import { CloseIcon } from './orgMenuIcons'

/**
 * Head of the side panel (mock `.osd-ev`): the event logo (44, initials without an image), the name
 * on two lines and "Dashboard" — a title, not a button. The × only exists on the ≤ 1100 drawer.
 */
export default function OrgSideHead({ name, iconLink, onClose }) {
    const { t } = useTranslation(TranslationNS.EVENT_PAGE)
    return (
        <div className="osd-head">
            <div className="osd-ev" id="osdTitle">
                <span className="osd-ev-logo" data-initials={initialsOf(name)}>
                    {iconLink ? <img src={iconLink} alt="" /> : null}
                </span>
                <span className="osd-ev-txt">
                    <span className="osd-ev-name">{name}</span>
                    <span className="osd-ev-sub">{t('Dashboard')}</span>
                </span>
            </div>
            <button type="button" className="osd-x" aria-label={t('Close')} onClick={onClose}>
                <CloseIcon />
            </button>
        </div>
    )
}
